


export const brokerFieldMap = {
    1: {
        "Order ID": "order_id",
        "Status": "orderStatus",
        "Transaction Type": "transactionType",
        "Exchange": "exchangeSegment",
        "Product Type": "productType",
        "Order Type": "orderType",
        "Quantity": "quantity",
        "Trading Symbol": "tradingSymbol",
        "Order Time": "createTime",
        "Message": "omsErrorDescription"
    },
    2: {
        "Order ID": "nestordernumber",
        "Status": "Status",
        "Transaction Type": "Action",
        "Exchange": "exchange",
        "Product Type": "productcode",
        "Order Type": "Ordtype",
        "Quantity": "Qty",
        "Trading Symbol": "Trsym",
        "Order Time": "exchangetimestamp",
        "Message": "rejectionreason"
    },
    3: {

        "Order ID": "order_id",
        "Status": "orderStatus",
        "Transaction Type": "transactionType",
        "Exchange": "exchangeSegment",
        "Product Type": "productType",
        "Order Type": "orderType",
        "Quantity": "quantity",
        "Trading Symbol": "tradingSymbol",
        "Order Time": "createTime",
        "Message": "omsErrorDescription"
    },
    4: {

        "Order ID": "order_id",
        "Status": "orderStatus",
        "Transaction Type": "transactionType",
        "Exchange": "exchangeSegment",
        "Product Type": "productType",
        "Order Type": "orderType",
        "Quantity": "quantity",
        "Trading Symbol": "tradingSymbol",
        "Order Time": "createTime",
        "Message": "omsErrorDescription"

    },
    5: {

        "Order ID": "order_id",
        "Status": "status",
        "Transaction Type": "transaction_type",
        "Exchange": "exchange",
        "Product Type": "product",
        "Order Type": "order_type",
        "Quantity": "quantity",
        "Trading Symbol": "tradingsymbol",
        "Order Time": "order_timestamp",
        "Message": "status_message"

    },
    6: {
        "Order ID": "order_id",
        "Status": "status",
        "Transaction Type": "transaction_type",
        "Exchange": "exchange",
        "Product Type": "product",
        "Order Type": "order_type",
        "Quantity": "quantity",
        "Trading Symbol": "trading_symbol",
        "Order Time": "order_timestamp",
        "Message": "status_message"
    },
    7: {
        "Order ID": "orderId",
        "Status": "orderStatus",
        "Price": "price",
        "Transaction Type": "transactionType",
        "Exchange": "exchangeSegment",
        "Product Type": "productType",
        "Order Type": "orderType",
        "Quantity": "quantity",
        "Trading Symbol": "tradingSymbol",
        "Order Time": "createTime",
        "Message": "omsErrorDescription"
    }
};
